import React from 'react';
import locale from "locale";
import {
    Button,
    Glyphicon,
    Checkbox,
} from 'react-bootstrap';

const ParticipantGroup = ({
    group,
    children,
    onGroupUpdate,
    onGroupRemove,
    onMove,
    index,
    isShowMoveUp,
    isShowMoveDown
}) => {
    return (
        <>
            <div style={{display: 'flex'}}>
                <div style={{flex: 1}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <h4 style={{margin: 0}}>
                            <strong>{locale.field(group.role, 'title')}</strong>
                        </h4>&nbsp;
                        <Button bsSize="small" onClick={() => onGroupRemove(group.id)}><Glyphicon glyph="trash" /></Button>
                    </div>
                    <Checkbox
                        checked={group.hideOnPlatform}
                        onChange={(e) => onGroupUpdate({...group, hideOnPlatform: e.target.checked})}
                    >
                        Скрыть на платформе
                    </Checkbox>
                    <Checkbox
                        checked={group.showTopics}
                        name="showTopics"
                        onChange={(e) => {
                            onGroupUpdate({...group, showTopics: e.target.checked})
                        }}
                    >
                        Показывать тему выступления у спикеров
                    </Checkbox>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                    {isShowMoveUp && (
                        <Button onClick={() => onMove(index - 1)}>
                            <Glyphicon glyph="arrow-up" />
                        </Button>
                    )}
                    {isShowMoveDown && (
                        <Button onClick={() => onMove(index + 1)}>
                            <Glyphicon glyph="arrow-down" />
                        </Button>
                    )}
                </div>
            </div>
            {children}
            <hr />
        </>
    )
};

export default ParticipantGroup;
